import React, { Fragment, isValidElement } from 'react'
import { isArray, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { Skeleton } from '@material-ui/lab'
import {
  Box,
  colors,
  Divider,
  Paper,
  Tooltip,
  Typography,
} from '@material-ui/core'

import theme from 'theme'
import useStyles from './styles'

const CommonTypography = ({ value, classes }) => {
  if (isValidElement(value)) return value

  const validationValue = isEmpty(value) ? 'Não informado' : value

  return (
    <Tooltip title={validationValue} placement="bottom-start">
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.typography}
      >
        {validationValue}
      </Typography>
    </Tooltip>
  )
}

const TicketInfo = ({ items, isLoading = false, ...rest }) => {
  const classes = useStyles()

  return (
    <Paper variant="outlined" {...rest}>
      <Box px={3} py={2}>
        <Typography variant="subtitle1" color="primary">
          Informações
        </Typography>
      </Box>
      {items?.map((option, index) => {
        if (!option.visible) return <Fragment key={index} />

        const highlight = option?.highlight
          ? colors.lightGreen['A100']
          : theme.palette.common.white

        return (
          <Box key={index}>
            <Divider />
            <Box px={3} py={2} bgcolor={highlight}>
              {isLoading ? (
                <Skeleton width="100%" variant="text" />
              ) : (
                option?.label && (
                  <Tooltip title={option?.label ?? ''} placement="bottom-start">
                    <Typography
                      variant="subtitle2"
                      color="primary"
                      className={classes.typography}
                    >
                      {option.label}
                    </Typography>
                  </Tooltip>
                )
              )}
              {isArray(option?.value) && !isEmpty(option?.value) ? (
                option?.value?.map((value, subIndex) =>
                  isLoading ? (
                    <Skeleton key={subIndex} width="100%" variant="text" />
                  ) : (
                    <CommonTypography
                      key={subIndex}
                      value={value}
                      classes={classes}
                    />
                  ),
                )
              ) : isLoading ? (
                <Skeleton width="100%" variant="text" />
              ) : (
                <CommonTypography value={option?.value} classes={classes} />
              )}
            </Box>
          </Box>
        )
      })}
    </Paper>
  )
}

TicketInfo.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool,
}

CommonTypography.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node,
  ]),
  classes: PropTypes.object.isRequired,
}

export default TicketInfo
